function passwordValidation(value) {
  const hasUpperCase = /[A-Z]/.test(value);
  const hasLowerCase = /[a-z]/.test(value);
  const hasNumber = /[0-9]/.test(value);
  const hasSymbole = /[@#$%^&+=)!?.]/.test(value);
  const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSymbole];
  const validConditions = conditions.reduce((acc, condition) => (condition ? ++acc : acc), 0);
  return validConditions === conditions.length;
}

export default passwordValidation;
